import { Component, OnInit } from '@angular/core';
import { ConfirmationService, Message, SelectItem } from 'primeng/api';
import { Institution } from '../../models/inModels/Institution';
import { LazyLoadEvent } from '../../models/DataTables/lazyLoadEvent';
import { Router } from '@angular/router';
import { StorageService } from '../../services/system/storage.service';
import { DataTable } from 'primeng/primeng';
import { InstitutionService } from '../../services/institution.service';

@Component({
  selector: 'app-institutions',
  templateUrl: './institutions.component.html',
  styleUrls: ['./institutions.component.css']
})
export class InstitutionsComponent implements OnInit {
  loading: boolean;
  messages: Message[];
  institution: Institution[];
  rows: SelectItem[];
  error: Message[];
  rowEvent: LazyLoadEvent;
  totalRecords: number;
  filteredRecords: number;
  selectedRows: number;
  constructor(
    private router: Router,
    private confirmationService: ConfirmationService,
    public storageService: StorageService,
    private institutionService: InstitutionService,
  ) {
    this.loading = true;
    this.rows = [];
    this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;
   }

  ngOnInit() {
  }

  changeRows(event): void {
    this.loadInstitutions(this.rowEvent);
  }

  reset(dt: DataTable, gb: HTMLInputElement) {
    gb.value = '';
    dt.reset();
  } 

  loadInstitutions(event: LazyLoadEvent): void {
    this.loading = true;
      event.rows = this.selectedRows;
      this.rowEvent = event;
      this.institutionService.search(event).then(
        dataPager => {
          this.institution = dataPager.Data;
          this.filteredRecords = dataPager.FilteredRecords;
          this.totalRecords = dataPager.TotalRecords;
          this.loading = false;
        },
        error => {
          this.loading = false;
          console.log(error);
          this.institution = [];
          this.totalRecords = 0;
          this.filteredRecords = 0;
          this.error = [];
          this.error.push({ severity: 'error', summary: 'Error', detail: error });
        }
      );
  }

  delete(institution: Institution) {
    console.log(institution);
    this.confirmationService.confirm({
      message: `Are you sure you want to delete ${institution.Name}?`,
      header: 'Confirmation',
      icon: 'fa fa-trash-o',
      accept: () => {
        this.loading = true;
        this.institutionService.delete(institution.Id).then(
          result => {
            this.loading = false;
            this.loadInstitutions(this.rowEvent);
          },
          error => {
            this.loading = false;
            this.error = [];
            this.error.push({ severity: 'error', summary: 'Error', detail: error });
          });
      }
    })
  }
  
  edit(institution: Institution) {
		console.log(institution);
		this.router.navigate(['institutions/edit', institution.Id]);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/institutions/institutions.component.ts